export function normalizeDropdownValue<T>(value: T | null | undefined, defaultValue?: T | string) {
	return value ?? defaultValue ?? "";
}